import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import PreviewPDF from './previewPDF';

const PeriodFilterHelper = ({
    setFilters,
    //setModalPdf
    filters,
    initDate = true,
    endDate = true,
    initTime = false,
    endTime = false,
    getReports,
    modal,
    setModal
}) => {
    //const [modal, setModal] = useState({show:false});
    const [datesTimer, setDatesTimer] = useState({ initDate: filters.initDate, endDate: filters.endDate });
    const formatDate = (date, name) => {
        let timeElapsed = new Date(date);
        let dateNow = `${timeElapsed.getFullYear()}-${(timeElapsed.getMonth() + 1) < 10 ? '0' : ''}${(timeElapsed.getMonth() + 1)}-${timeElapsed.getDate()}`;
        let dateFormat = `${dateNow}T${timeElapsed.getHours()}:${timeElapsed.getMinutes()}:00`;
        setFilters({ ...filters, [name]: dateFormat });
        setDatesTimer({ ...datesTimer, [name]: date })
    }

    return (
        <React.Fragment>
            {(initDate && !initTime) &&
                <div className="col-sm-2">
                    <label className="form-label">Fecha {initDate && endDate ? 'Inicial' : ''}:</label>
                    <input className="form-control" placeholder='Fecha' name="time" type="date" onChange={e => setFilters({ ...filters, initDate: e.target.value })} value={filters.initDate} />
                </div>
            }
            {initTime &&
                <div className="col-sm-2">
                    <label className="form-label">Fecha/Hora {initDate && endDate ? 'Inicial' : ''}:</label>
                    <DatePicker
                        className="form-control"
                        selected={datesTimer.initDate}
                        onChange={e => formatDate(e, 'initDate')}
                        showTimeSelect

                        dateFormat="dd-MM-yyyy HH:mm"
                    />
                </div>
            }
            {(endDate && !endTime) &&
                <div className="col-sm-2">
                    <label className="form-label">Fecha {initDate && endDate ? 'Final' : ''}:</label>
                    <input className="form-control" placeholder='Fecha' name="time" type="date" onChange={e => setFilters({ ...filters, endDate: e.target.value })} value={filters.endDate} />
                </div>
            }
            {endTime &&
                <div className="col-sm-2">
                    <label className="form-label">Fecha/Hora {initDate && endDate ? 'Final' : ''}:</label>
                    <DatePicker
                        className="form-control"
                        selected={datesTimer.endDate}
                        onChange={e => [formatDate(e, 'endDate'), console.log(new Date(e))]}
                        showTimeSelect
                        dateFormat="dd-MM-yyyy HH:mm"
                    />
                </div>
            }

            {modal.show && (
                <PreviewPDF modalPdf={modal} setModalPdf={setModal} />
            )}
        </React.Fragment>
    );
};

export default PeriodFilterHelper;
